import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
var CustomToast = function CustomToast(_ref) {
  var message = _ref.message,
    title = _ref.title,
    onClose = _ref.onClose,
    onCloseAll = _ref.onCloseAll;
  var _useState = useState(false),
    expanded = _useState[0],
    setExpanded = _useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "16px",
      background: "#fff",
      border: "1px solid hsl(0, 0%, 93%)",
      color: "hsl(0, 0%, 9%)",
      borderRadius: "8px",
      boxShadow: "0 4px 12px #0000001a",
      fontSize: "13px",
      display: "flex",
      alignItems: "center",
      gap: "6px",
      direction: "ltr",
      position: "relative",
      minWidth: "300px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "8px",
      position: "absolute",
      right: "10px",
      top: "15px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-close-button": true,
    style: {
      cursor: "pointer",
      borderRadius: "50%",
      background: "hsl(0, 0%, 93%)",
      padding: "4px",
      flexShrink: 0
    },
    role: "button",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "12px",
      height: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-x h-4 w-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 6 6 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 6 12 12"
  })))), /*#__PURE__*/React.createElement("div", {
    "data-dismiss-all": true,
    style: {
      cursor: "pointer",
      borderRadius: "50%",
      background: "hsl(0, 91%, 65%)",
      padding: "4px",
      flexShrink: 0
    },
    role: "button",
    onClick: onCloseAll
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "12px",
      height: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      color: "white"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 6H5m14 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
  }))))), /*#__PURE__*/React.createElement("div", {
    "data-content": true,
    style: {
      display: "flex",
      alignItems: "flex-start",
      gap: "2px",
      flexDirection: "column",
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-title": true,
    style: {
      fontWeight: 700,
      lineHeight: "1.25",
      color: "rgb(9, 9, 11)",
      fontSize: "14px",
      maxWidth: "250px",
      wordBreak: "break-word"
    }
  }, title), expanded ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("pre", {
    "data-description": true,
    style: {
      fontWeight: 400,
      lineHeight: "1.4",
      background: "rgb(2 6 23 / 1)",
      color: "rgb(255 255 255/ 1)",
      wordBreak: "break-word",
      padding: "16px 12px",
      borderRadius: "8px",
      fontFamily: "ui-monospace,monospace",
      maxHeight: "300px",
      overflow: "auto",
      whiteSpace: "pre-wrap"
    }
  }, message), /*#__PURE__*/React.createElement("p", {
    style: {
      cursor: "pointer",
      color: "hsl(0, 0%, 50%)",
      fontSize: "12px",
      textAlign: "center",
      width: "100%",
      fontWeight: 700,
      marginBottom: "-10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "10px"
    },
    onClick: function onClick() {
      return setExpanded(false);
    }
  }, "Collapse", /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    style: {
      cursor: "pointer",
      color: "hsl(0, 0%, 50%)",
      fontSize: "12px",
      textAlign: "center",
      width: "100%",
      fontWeight: 700,
      marginBottom: "-10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "10px"
    },
    onClick: function onClick() {
      return setExpanded(true);
    }
  }, "Expand", /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.793 8.707a1 1 0 1 0 1.414-1.414l-1.95-1.95c-.085-.085-.185-.186-.281-.267a1.5 1.5 0 0 0-.513-.295a1.5 1.5 0 0 0-.926 0a1.5 1.5 0 0 0-.513.295c-.096.081-.196.182-.28.266l-1.951 1.95a1 1 0 0 0 1.414 1.415L12 6.914zm-3.586 6.586a1 1 0 0 0-1.414 1.414l1.95 1.95c.085.085.185.186.281.267c.111.094.28.22.513.296a1.5 1.5 0 0 0 .926 0a1.5 1.5 0 0 0 .513-.296c.096-.081.196-.182.28-.266l1.951-1.95a1 1 0 0 0-1.414-1.415L12 17.086z"
  })))))));
};
export default CustomToast;